export default {"src":"/_next/static/image/public/home/dimensions.64cc9290d4a82616a69b6c187edbfb0e.svg","height":172,"width":172};